import { Box, Flex } from 'dash-ui';
import styled from 'styled-components';

export const ListWrapper = styled(Box)`
  .list {
    flex-wrap: wrap;

    & > div {
      margin-right: ${({ theme }) => theme.space * 10}px;
      margin-bottom: ${({ theme }) => theme.space * 4}px;
    }
  }
`;

export const EmptyContainer = styled(Flex)`
  text-align: center;
  border-radius: ${({ theme }) => theme.space * 2}px;
  border: 1px solid ${({ theme }) => theme.colors.n30};
`;
